import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../states/usuarios/AuthState';

const ExternalScripts: React.FC = () => {
  const user = useRecoilValue(authAtom);

  useEffect(() => {
    const loadGA4 = () => {
      const GA4_ID = 'G-ZL9DZPXQF8';
      
      // Load gtag.js script
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
      document.head.appendChild(gtagScript);

      // Initialize gtag
      const gtagConfigScript = document.createElement('script');
      gtagConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA4_ID}');
      `;
      document.head.appendChild(gtagConfigScript);

      console.log('Google Analytics 4 loaded with ID:', GA4_ID);
    };

    const loadTawk = () => {
      const tawkScript = document.createElement('script');
      tawkScript.type = 'text/javascript';
      tawkScript.innerHTML = `
        var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
        (function(){
          var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/686827f2d7341f1911948b8e/1ivbdo2tm';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
        })();
      `;
      document.head.appendChild(tawkScript);
    };

    const cleanupScripts = () => {
      const existingScripts = document.querySelectorAll('script[src*="googletagmanager.com"], script[src*="tawk.to"]');
      existingScripts.forEach(script => script.remove());

      // Remove any existing gtag scripts
      const existingGtagScripts = document.querySelectorAll('script[src*="gtag/js"]');
      existingGtagScripts.forEach(script => script.remove());
    };

    if (user && user.unidadeOperacionalId) {
      cleanupScripts();

      if (user.unidadeOperacionalId > 1) {
        return;
      }

      loadTawk();
      loadGA4();
    }

    return () => {
      cleanupScripts();
    };
  }, [user]);

  return null;
};

export default ExternalScripts;
